module.exports = __webpack_public_path__ + "static/media/delete_icon.70b41060.svg";